// Push registration is handled by the Expo shell (expo-notifications) in the
// /mobile-app project. In the browser this is a no-op.
export async function registerPushForUser() {
  /* no-op on web */
}
